import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { HttpClient } from "@angular/common/http";

import { AuthService } from "src/app/_app-core/services/auth/auth.service";

@Component({
    selector: "app-vendor-master-data",
    templateUrl: "./vendor-master-data.component.html",
    styleUrls: ["./vendor-master-data.component.css"],
})
export class VendorMasterDataComponent implements OnInit {
    masterData: any;
    responseData: any;
    isError = false;
    vendorData: any;
    freqExist = false;
    statusExist = false;

    constructor(
        private router: Router,
        private http: HttpClient,
        private authService: AuthService
    ) {}

    confirmDetails() {
        this.router.navigateByUrl("/password-change-onboarding");
    }

    ngOnInit(): void {
        const userData = {
            sellerCode: localStorage.getItem("vendorCode"),
            session: { sessionId: localStorage.getItem("userSession") },
        };

        this.authService.fetchVendorMasterData(userData).subscribe(
            (res) => {
                this.responseData = res;
                if (this.responseData.status == "success") {
                    console.log("You did it");
                    this.vendorData = this.responseData.supplier;

                    if (
                        typeof this.vendorData.tax_return_status !==
                            "undefined" &&
                        this.vendorData.tax_return_status !== ""
                    ) {
                        this.statusExist = true;
                    }

                    if (
                        typeof this.vendorData.tax_return_frequency !==
                            "undefined" &&
                        this.vendorData.tax_return_frequency !== ""
                    ) {
                        this.freqExist = true;
                    }
                } else {
                    this.isError = true;
                    console.log("Error Here");
                }
            },
            (error) => {
                this.isError = true;
                console.log(error);
            }
        );
    }
}
